import React from 'react'
import AlertIcon from "../../../assets/icons/AlertIcon.svg"
import "../ProfileD.css"
import {convertDate } from '../../../shared/helpers'

const PlaceBidDisclaimer = ({email,date="2024-06-11T11:38:57.038Z", isInvited , employerName}) => {
  return (
    <div className="bid-place-div">
      {isInvited ? (
        <>{" "}
        <div>
            <img className="alert-icon" src={AlertIcon} alt="Alert Icon" />
        </div>
          <div className="bid-place-text">
          Invitation email has been sent by {employerName}  ({email}) on {convertDate(date) || "N/A"}. 
          You will be able to place a bid after the candidate has completed the sign up successfully.
          </div>
        </>
      ) : (
        <>
          {" "}
          <div>
            <img className="alert-icon" src={AlertIcon} alt="Alert Icon" />
          </div>
          <div className="bid-place-text">
            Bid already placed by your ABS team member{" "}
            <span style={{ fontWeight: "600" }}>{email || ""} </span>
            on {convertDate(date)}.
          </div>
        </>
      )}
    </div>
  );
}

export default PlaceBidDisclaimer